import * as React from 'react';
import classnames from 'classnames';

const ProductListingGridCell = ({ children , isWide =false ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('product-listing-grid-cell', {
            'product-listing-grid-cell--wide': isWide
        })
    }, children)
;
var ProductListingGridCell$1 = ProductListingGridCell;

export { ProductListingGridCell$1 as default };
//# sourceMappingURL=ProductListingGridCell.js.map
